import { render, staticRenderFns } from "./ProductOrderWasteList.vue?vue&type=template&id=2ce00729&scoped=true&"
import script from "./ProductOrderWasteList.vue?vue&type=script&lang=js&"
export * from "./ProductOrderWasteList.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderWasteList.vue?vue&type=style&index=0&id=2ce00729&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce00729",
  null
  
)

export default component.exports